import { render, staticRenderFns } from "./AuditTrail.vue?vue&type=template&id=160d9dc8&scoped=true"
import script from "./AuditTrail.vue?vue&type=script&lang=js"
export * from "./AuditTrail.vue?vue&type=script&lang=js"
import style0 from "./AuditTrail.vue?vue&type=style&index=0&id=160d9dc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160d9dc8",
  null
  
)

/* custom blocks */
import block0 from "./AuditTrail.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports